import Vue from 'vue';
import Router from 'vue-router';

import routes from './routes';
import {
    publicGuard,
    proGuard,
    userDataGuard,
    offboardingGuard,
    suspendedGuard,
    subscriptionChangeGuard,
    settingsProUserGuard,
    modalGuard,
} from './guards';

Vue.use(Router);

/**
 * Register router
 */
const router = new Router({
    /**
     * Router mode
     */
    mode: 'history',

    /**
     * Router routes
     */
    routes,

    /**
     * Router scroll parameters
     *
     * @param {object} to Route navigated to.
     *
     * @returns  {object}  Scroll position
     */
    scrollBehavior(to) {
        if (to.hash) {
            return {
                selector: to.hash,
            };
        } else {
            return {
                x: 0,
                y: 0,
            };
        }
    },
});

router.beforeEach(userDataGuard());
router.beforeEach(publicGuard(router));
router.beforeEach(proGuard(router));
router.beforeEach(settingsProUserGuard(router));
router.beforeEach(offboardingGuard(router));
router.beforeEach(suspendedGuard(router));
router.beforeEach(subscriptionChangeGuard(router));
router.beforeEach(modalGuard());

export default router;
